import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './components/App';
// import * as serviceWorker from './serviceWorker';
import './scss/scss-styles.scss'; // all compiled scss
import { app_build_version_id_zzyourmap } from './utils/zz/zz-yourmap-config';


console.log('Zdravo');
console.log('React.version', React.version); // check React version
// export const app_build_version_id = 'build2026-04-07r2'; // UNIQUE ID FOR LAST CHANGES TO THIS APP - FOR FASIER TRACKING OF COMMITS AND BUILDS
export const app_build_version_id = app_build_version_id_zzyourmap; // UNIQUE ID FOR LAST CHANGES TO THIS APP - FOR FASIER TRACKING OF COMMITS AND BUILDS
console.log('app version ID: ', app_build_version_id);

/*
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
*/
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
